import { Box } from "@mui/material";
import { v2 } from "./v2Tokens";
import { MENU_TYPE_LABELS, type MenuTypeV2 } from "../model/nutritionV2Model";

const TYPE_CHIPS: Record<MenuTypeV2, { color: string; bg: string }> = {
  DETAILED_PLAN: { color: "#1A3FA0", bg: "#EDF2FF" },
  MACRO_GOALS: { color: v2.warn, bg: v2.warnWash },
  PDF_PLAN: { color: v2.over, bg: v2.overWash },
};

/**
 * What KIND of menu this is — read-only, everywhere it appears.
 *
 * The type is decided once, on the way out of the calculator, and is then part of what the menu
 * IS: a PDF menu is its file, a macro menu is its numbers, a detailed menu is its meals. The
 * builder used to carry a segmented control that switched between them at any time, which meant
 * the same menu could be three different things over its life — and the trainee's app, the
 * templates and the list all read a type that could change under them. Now the list and the
 * builder show the SAME chip, from one place, and neither of them can change it.
 */
const MenuTypeChip = ({ menuType, title }: { menuType: MenuTypeV2; title?: string }) => {
  const conf = { label: MENU_TYPE_LABELS[menuType], ...TYPE_CHIPS[menuType] };
  return (
    <Box
      component="span"
      title={title}
      sx={{
        display: "inline-block",
        fontSize: 11,
        fontWeight: 700,
        padding: "2px 10px",
        borderRadius: "20px",
        background: conf.bg,
        color: conf.color,
        whiteSpace: "nowrap",
      }}
    >
      {conf.label}
    </Box>
  );
};

export default MenuTypeChip;
